export enum STATE_NAMES {
    ACTIVE_PROJECTS_PAGE = 'activeProjectsPage',
    COMPLETED_PROJECTS_PAGE = 'completedProjectsPage',
    CONCEPT_BRIEFINGS_PAGE = 'conceptBriefingsPage',
    PROJECT_LIST = 'projectList',
    PROJECT_TYPES = 'projectTypes',
    LANGUAGES = 'filterLanguages', // ToDo refactor language reducers into a slice and rename this to 'language'
    PROJECT_PAGE_FILTERS = 'projectPageFilters',
};